var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record[_vm.primaryFilter])?_c('p',{staticClass:"subtitle is-hidden-desktop is-hidden-tablet-only"},[_c('fa',{staticClass:"fa-fw",attrs:{"icon":"chevron-right"}}),_vm._v(" "+_vm._s(_vm.primaryFilterField)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }